export const Music = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="22.5" cy="22.5" r="3.5" stroke="currentColor" stroke-width="2"/>
<circle cx="6.5" cy="24.5" r="3.5" stroke="currentColor" stroke-width="2"/>
<path d="M26 22.5V5.20493C26 4.57879 25.4311 4.10666 24.8157 4.22205L10.8157 6.84705C10.3427 6.93574 10 7.34871 10 7.82993V24" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M26 8L10 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
